import en from "./en";
const fr = {
  ...en,
  nav: {
    home: "Accueil",
    about: "L'Alliance",
    markets: "Marchés",
    services: "Services",
    partners: "Partenaires",
    manufacturers: "Pour les Constructeurs",
    news: "Actualités",
    contact: "Contact",
    partner_cta: "Devenir Partenaire",
  },
  hero: {
    eyebrow: "European Electric Mobility Alliance",
    title_line1: "La plateforme européenne de distribution",
    title_line2: "pour la mobilité électrique",
    subtitle: "Nous relions les constructeurs au réseau de distribution le plus expérimenté d'Europe. Nous n'importons pas de véhicules. Nous construisons des marques.",
    cta_primary: "Devenir Partenaire",
    cta_secondary: "Découvrir l'Alliance",
    scroll: "Faites défiler pour découvrir",
  },
  cta_final: {
    eyebrow: "Partenariat stratégique",
    title: "Prêt à vous développer en Europe ?",
    subtitle: "Collaborez avec EEMA et bénéficiez d'une plateforme commerciale établie couvrant les marchés européens stratégiques de la mobilité électrique.",
    button: "Demander un rendez-vous",
  },
};
export default fr;
